export default __webpack_public_path__ + "static/media/dropImage.adf00592.svg";